import { Component, input, computed } from '@angular/core';
import { BaseComponent } from '@app/entities/paragraph/base/base.component';
import { ParagraphPgAcComponent } from '@app/entities/paragraph/paragraph-pg-ac/paragraph-pg-ac.component';
import { ParagraphPgCeComponent } from '@app/entities/paragraph/paragraph-pg-ce/paragraph-pg-ce.component';
import { ParagraphPgClComponent } from '@app/entities/paragraph/paragraph-pg-cl/paragraph-pg-cl.component';
import { ParagraphPgConComponent } from '@app/entities/paragraph/paragraph-pg-con/paragraph-pg-con.component';
import { ParagraphPgConRefComponent } from '@app/entities/paragraph/paragraph-pg-con-ref/paragraph-pg-con-ref.component';
import { ParagraphPgCoperComponent } from '@app/entities/paragraph/paragraph-pg-coper/paragraph-pg-coper.component';
import { ParagraphPgCsrmComponent } from '@app/entities/paragraph/paragraph-pg-csrm/paragraph-pg-csrm.component';
import { ParagraphPgCtComponent } from '@app/entities/paragraph/paragraph-pg-ct/paragraph-pg-ct.component';
import { ParagraphPgCtabComponent } from '@app/entities/paragraph/paragraph-pg-ctab/paragraph-pg-ctab.component';
import { ParagraphPgCtarComponent } from '@app/entities/paragraph/paragraph-pg-ctar/paragraph-pg-ctar.component';
import { ParagraphPgDownloadComponent } from '@app/entities/paragraph/paragraph-pg-download/paragraph-pg-download.component';
import { ParagraphPgEmbedComponent } from '@app/entities/paragraph/paragraph-pg-embed/paragraph-pg-embed.component';
import { ParagraphPgFaqComponent } from '@app/entities/paragraph/paragraph-pg-faq/paragraph-pg-faq.component';
import { ParagraphPgFormComponent } from '@app/entities/paragraph/paragraph-pg-form/paragraph-pg-form.component';
import { ParagraphPgGasComponent } from '@app/entities/paragraph/paragraph-pg-gas/paragraph-pg-gas.component';
import { ParagraphPgHhComponent } from '@app/entities/paragraph/paragraph-pg-hh/paragraph-pg-hh.component';
import { ParagraphPgHposComponent } from '@app/entities/paragraph/paragraph-pg-hpos/paragraph-pg-hpos.component';
import { ParagraphPgHslComponent } from '@app/entities/paragraph/paragraph-pg-hsl/paragraph-pg-hsl.component';
import { ParagraphPgHtlComponent } from '@app/entities/paragraph/paragraph-pg-htl/paragraph-pg-htl.component';
import { ParagraphPgIgComponent } from '@app/entities/paragraph/paragraph-pg-ig/paragraph-pg-ig.component';
import { ParagraphPgImgComponent } from '@app/entities/paragraph/paragraph-pg-img/paragraph-pg-img.component';
import { ParagraphPgLcComponent } from '@app/entities/paragraph/paragraph-pg-lc/paragraph-pg-lc.component';
import { ParagraphPgLlComponent } from '@app/entities/paragraph/paragraph-pg-ll/paragraph-pg-ll.component';
import { ParagraphPgMapComponent } from '@app/entities/paragraph/paragraph-pg-map/paragraph-pg-map.component';
import { ParagraphPgPaComponent } from '@app/entities/paragraph/paragraph-pg-pa/paragraph-pg-pa.component';
import { ParagraphPgPacsComponent } from '@app/entities/paragraph/paragraph-pg-pacs/paragraph-pg-pacs.component';
import { ParagraphPgPcwComponent } from '@app/entities/paragraph/paragraph-pg-pcw/paragraph-pg-pcw.component';
import { ParagraphPgPisComponent } from '@app/entities/paragraph/paragraph-pg-pis/paragraph-pg-pis.component';
import { ParagraphPgPsesComponent } from '@app/entities/paragraph/paragraph-pg-pses/paragraph-pg-pses.component';
import { ParagraphPgPuspComponent } from '@app/entities/paragraph/paragraph-pg-pusp/paragraph-pg-pusp.component';
import { ParagraphPgSlocComponent } from '@app/entities/paragraph/paragraph-pg-sloc/paragraph-pg-sloc.component';
import { ParagraphPgTeComponent } from '@app/entities/paragraph/paragraph-pg-te/paragraph-pg-te.component';
import { ParagraphPgTlComponent } from '@app/entities/paragraph/paragraph-pg-tl/paragraph-pg-tl.component';
import { ParagraphPgTlsComponent } from '@app/entities/paragraph/paragraph-pg-tls/paragraph-pg-tls.component';
import { ParagraphPgTtlComponent } from '@app/entities/paragraph/paragraph-pg-ttl/paragraph-pg-ttl.component';
import { ParagraphPgTsComponent } from '@app/entities/paragraph/paragraph-pg-ts/paragraph-pg-ts.component';
import { ParagraphPgTsrComponent } from '@app/entities/paragraph/paragraph-pg-tsr/paragraph-pg-tsr.component';
import { ParagraphPgTsvcComponent } from '@app/entities/paragraph/paragraph-pg-tsvc/paragraph-pg-tsvc.component';
import { ParagraphPgTtComponent } from '@app/entities/paragraph/paragraph-pg-tt/paragraph-pg-tt.component';
import { ParagraphPgTxtComponent } from '@app/entities/paragraph/paragraph-pg-txt/paragraph-pg-txt.component';
import { ParagraphPgUspComponent } from '@app/entities/paragraph/paragraph-pg-usp/paragraph-pg-usp.component';
import { ParagraphPgViComponent } from '@app/entities/paragraph/paragraph-pg-vi/paragraph-pg-vi.component';
import { ParagraphPgGbocComponent } from '@app/entities/paragraph/paragraph-pg-gboc/paragraph-pg-gboc.component';
import { ParagraphPgLegalAdvisorComponent } from '@app/entities/paragraph/paragraph-pg-legal-advisor/paragraph-pg-legal-advisor.component';
import { ParagraphPgQusComponent } from '@app/entities/paragraph/paragraph-pg-qus/paragraph-pg-qus.component';
import { ParagraphPgStrComponent } from '@app/entities/paragraph/paragraph-pg-str/paragraph-pg-str.component';
import { ParagraphPgImgrComponent } from '@app/entities/paragraph/paragraph-pg-imgr/paragraph-pg-imgr.component';
import { ParagraphPgGateComponent } from '@app/entities/paragraph/paragraph-pg-gate/paragraph-pg-gate.component';
import { ParagraphPgPpsComponent } from './paragraph-pg-pps/paragraph-pg-pps.component';

@Component({
  selector: 'mobi-paragraph-loader',
  template: `
    <!-- Keep embedded content and videos hydrated without waiting for idle. -->
    @if (bundle() === 'ParagraphPgEmbed') {
      <mobi-paragraph-pg-embed [paragraph]="data().paragraph" />
    } @else if (bundle() === 'ParagraphPgVi') {
      <mobi-paragraph-pg-vi [paragraph]="data().paragraph" />
    } @else {
      @defer (hydrate on idle) {
        @switch (bundle()) {
          @case ('ParagraphPgAc') {
            <mobi-paragraph-pg-ac [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCe') {
            <mobi-paragraph-pg-ce [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCl') {
            <mobi-paragraph-pg-cl [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCon') {
            <mobi-paragraph-pg-con [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgConRef') {
            <mobi-paragraph-pg-con-ref [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCoper') {
            <mobi-paragraph-pg-coper [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCsrm') {
            <mobi-paragraph-pg-csrm [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCt') {
            <mobi-paragraph-pg-ct [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCtab') {
            <mobi-paragraph-pg-ctab [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgCtar') {
            <mobi-paragraph-pg-ctar [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgDownload') {
            <mobi-paragraph-pg-download [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgFaq') {
            <mobi-paragraph-pg-faq [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgForm') {
            <mobi-paragraph-pg-form [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgGas') {
            <mobi-paragraph-pg-gas [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgHh') {
            <mobi-paragraph-pg-hh [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgHpos') {
            <mobi-paragraph-pg-hpos [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgHsl') {
            <mobi-paragraph-pg-hsl [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgHtl') {
            <mobi-paragraph-pg-htl [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgIg') {
            <mobi-paragraph-pg-ig [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgImg') {
            <mobi-paragraph-pg-img [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgLc') {
            <mobi-paragraph-pg-lc [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgLl') {
            <mobi-paragraph-pg-ll [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgMap') {
            <mobi-paragraph-pg-map [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPa') {
            <mobi-paragraph-pg-pa [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPacs') {
            <mobi-paragraph-pg-pacs [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPcw') {
            <mobi-paragraph-pg-pcw [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPis') {
            <mobi-paragraph-pg-pis [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPses') {
            <mobi-paragraph-pg-pses [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPusp') {
            <mobi-paragraph-pg-pusp [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgQus') {
            <mobi-paragraph-pg-qus [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgSloc') {
            <mobi-paragraph-pg-sloc [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTe') {
            <mobi-paragraph-pg-te [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTl') {
            <mobi-paragraph-pg-tl
              [paragraph]="data().paragraph"
              [teaserStyle]="data().teaserStyle"
            />
          }
          @case ('ParagraphPgTls') {
            <mobi-paragraph-pg-tls [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTtl') {
            <mobi-paragraph-pg-ttl [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTs') {
            <mobi-paragraph-pg-ts [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTsr') {
            <mobi-paragraph-pg-tsr [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTsvc') {
            <mobi-paragraph-pg-tsvc [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTt') {
            <mobi-paragraph-pg-tt [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgTxt') {
            <mobi-paragraph-pg-txt [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgUsp') {
            <mobi-paragraph-pg-usp [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgGboc') {
            <mobi-paragraph-pg-gboc [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgLegalAdvisor') {
            <mobi-paragraph-pg-legal-advisor [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgStr') {
            <mobi-paragraph-pg-str [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgImgr') {
            <mobi-paragraph-pg-imgr [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgGate') {
            <mobi-paragraph-pg-gate [paragraph]="data().paragraph" />
          }
          @case ('ParagraphPgPps') {
            <mobi-paragraph-pg-pps [paragraph]="data().paragraph" />
          }
          @default {
            <mobi-paragraph-base
              [entity]="data().paragraph"
              [paragraph]="data().paragraph"
            />
          }
        }
      }
    }
  `,
  standalone: true,
  imports: [
    BaseComponent,
    ParagraphPgAcComponent,
    ParagraphPgCeComponent,
    ParagraphPgClComponent,
    ParagraphPgConComponent,
    ParagraphPgConRefComponent,
    ParagraphPgCoperComponent,
    ParagraphPgCsrmComponent,
    ParagraphPgCtComponent,
    ParagraphPgCtabComponent,
    ParagraphPgCtarComponent,
    ParagraphPgDownloadComponent,
    ParagraphPgEmbedComponent,
    ParagraphPgFaqComponent,
    ParagraphPgFormComponent,
    ParagraphPgGasComponent,
    ParagraphPgHhComponent,
    ParagraphPgHposComponent,
    ParagraphPgHslComponent,
    ParagraphPgHtlComponent,
    ParagraphPgIgComponent,
    ParagraphPgImgComponent,
    ParagraphPgLcComponent,
    ParagraphPgLlComponent,
    ParagraphPgMapComponent,
    ParagraphPgPaComponent,
    ParagraphPgPacsComponent,
    ParagraphPgPcwComponent,
    ParagraphPgPisComponent,
    ParagraphPgPsesComponent,
    ParagraphPgPuspComponent,
    ParagraphPgSlocComponent,
    ParagraphPgTeComponent,
    ParagraphPgTlComponent,
    ParagraphPgTlsComponent,
    ParagraphPgTtlComponent,
    ParagraphPgTsComponent,
    ParagraphPgTsrComponent,
    ParagraphPgTsvcComponent,
    ParagraphPgTtComponent,
    ParagraphPgTxtComponent,
    ParagraphPgUspComponent,
    ParagraphPgViComponent,
    ParagraphPgGbocComponent,
    ParagraphPgLegalAdvisorComponent,
    ParagraphPgQusComponent,
    ParagraphPgStrComponent,
    ParagraphPgImgrComponent,
    ParagraphPgGateComponent,
    ParagraphPgPpsComponent,
  ],
  host: {
    '[class.pg-ll-is-acc]': 'isPgLlAccordion()',
  },
})
export class ParagraphLoaderComponent {
  readonly bundle = input.required<string>();
  readonly data = input<any>({});
  isPgLlAccordion = computed(
    () => this.bundle() === 'ParagraphPgLl' && this.data()?.paragraph?.linksAsAccordion
  );
}
